import { SET_LANGUAGE, SET_SEARCH } from "../actions/types";

const initialState = {
  language: 0,
  search: "",
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    default:
      return state;
  }
}
